<template>
  <div class="about">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>{{ authUser.name }}</span>
            </h1>
            <div class="page-header-subtitle">Profile</div>
          </div>
        </div>
      </div>
      <div class="container mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <div class="card-body">
                <div class="row">
                  <div class="col-3">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                      <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true">Account Detail</a>
                      <a class="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#v-pills-profile" role="tab" aria-controls="v-pills-profile" aria-selected="false">Reset Password</a>
                    </div>
                  </div>
                  <div class="col-9">
                    <div class="tab-content" id="v-pills-tabContent">
                      <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                        <h3>Account Details</h3>
                        <table class="table">
                          <tr>
                            <th>Fullname</th>
                            <td>{{ user.name }}</td>
                          </tr>
                          <tr>
                            <th>Email/Username</th>
                            <td>{{ user.email }}</td>
                          </tr>
                          <tr>
                            <th>Phone Number</th>
                            <td>{{ user.phone }}</td>
                          </tr>
                          <tr>
                            <th>Role</th>
                            <td>{{ user.role.name }}</td>
                          </tr>
                        </table>
                      </div>
                      <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                        <h3>Reset Password</h3>
                        <form @submit.prevent="handleSubmit">
                          <div class="form-group">
                            <label for="exampleInputEmail1">Current password</label>
                            <input v-model="currentPassword" type="password" class="form-control" :class="{ 'is-invalid': $v.currentPassword.$error, 'is-valid': !$v.currentPassword.$invalid }" />
                            <div class="invalid-feedback">
                              <span v-if="!$v.currentPassword.required">Current Password is required.</span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="exampleInputPassword1">New password</label>
                            <input v-model="newPassword" type="password" class="form-control" :class="{ 'is-invalid': $v.newPassword.$error, 'is-valid': !$v.newPassword.$invalid }" />
                            <div class="invalid-feedback">
                              <span v-if="!$v.newPassword.required">New password is required.</span>
                              <span v-if="!$v.newPassword.minLength">New password must be at least {{ $v.newPassword.$params.minLength.min }} letters.</span>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="exampleInputPassword1">Confirm new password</label>
                            <input v-model="confirmPassword" type="password" class="form-control" :class="{ 'is-invalid': $v.confirmPassword.$error, 'is-valid': !$v.confirmPassword.$invalid }" />
                            <div class="invalid-feedback">
                              <span v-if="!$v.newPassword.required">Confirm new password is required.</span>
                              <span v-if="!$v.confirmPassword.sameAs">New Passwords must be identical.</span>
                            </div>
                          </div>

                          <button type="submit" class="btn btn-primary" :disabled="disableBtn">Submit</button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- fff -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import { required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  name: "Profile",

  data() {
    return {
      user: { role: {} },
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      disableBtn: false,
    };
  },

  validations: {
    currentPassword: { required },
    newPassword: { required, minLength: minLength(6) },
    confirmPassword: { required, sameAs: sameAs("newPassword") },
  },

  methods: {
    handleSubmit() {
      this.disableBtn = true;
      let loading = this.$loading.show();
      this.$v.$touch();
      if (this.$v.$invalid) {
        loading.hide();
        this.disableBtn = false;
        return;
      }
      let formData = new FormData();
      formData.append("currentPassword", this.currentPassword);
      formData.append("newPassword", this.newPassword);
      formData.append("email", this.authUser.email);

      axios.post("/user/reset-password", formData).then((res) => {
        if (res.data.status == "success") {
          this.$swal("Good!", res.data.message, "success");
          this.$v.$reset();
          this.currentPassword = "";
          this.newPassword = "";
          this.confirmPassword = "";
        } else {
          this.$swal("Oops!", res.data.message, "error");
        }
      });
      this.disableBtn = false;
      loading.hide();
    },
  },

  mounted() {
    let formData = new FormData();
    formData.append("email", this.authUser.email);
    let loading = this.$loading.show();
    axios.post("/user", formData).then((res) => {
      this.user = res.data.user;
      loading.hide();
    });
  },

  computed: {
    authUser() {
      return this.$store.state.authUser;
    },
  },
};
</script>